import React from "react";
import { useInvoice } from "../../../hooks";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import ExpensesReportsListItem from "./ExpensesReportsListItem";
const ExpensesReportsList = ({ data }) => {
  const { t } = useTranslation("global");
  const { formatter } = useInvoice();

  return (
    <div className="my-5 rounded-lg bg-white">
      <div className="flex gap-2 justify-between font-bold items-center text-[#261759] bg-[#EBF9D9] py-1 px-2 rounded-t-lg text-sm">
        <div className="w-5 text-center">#</div>
        <div className="w-28 text-center">{t("expenses.expensesNumber")}</div>
        <div className="flex-1 text-center">
          {t("expenses.expensesDescription")}
        </div>
        <div className="w-36 text-center">{t("reports.saller_name")}</div>
        <div className="w-36 text-center">{t("expenses.expensesDate")}</div>
        <div className="w-36 text-center">{t("expenses.expensesAmount")}</div>
        <div className="w-32 text-center">

        {t("Salaries.Vat")}

        </div>
      </div>
      {data.data.map((item , index) => (
        <ExpensesReportsListItem key={item.id} item={item} index={index}  formatter={formatter} />
      ))}
    </div>
  );
};

export default ExpensesReportsList;
